import type { ReactNode } from 'react';
import { CARD_GRID_COLUMNS_CLASSES } from '@/constants/layout';
import { cn } from '@/lib/utils';

interface EventsGridProps {
    children: ReactNode;
}

export function EventsGrid({ children }: EventsGridProps) {
    return (
        <div className={cn('grid gap-4 pb-6', CARD_GRID_COLUMNS_CLASSES)}>
            {children}
        </div>
    );
}
